"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractCdsz = extractCdsz;
exports.findCdszEntryByBasename = findCdszEntryByBasename;
exports.readCdszEntryAsText = readCdszEntryAsText;
const fflate_1 = require("fflate");
const utf8Decoder = new TextDecoder('utf-8');
function extractCdsz(data) {
    const unzipped = (0, fflate_1.unzipSync)(data);
    const entries = new Map();
    for (const path of Object.keys(unzipped)) {
        if (path.endsWith('/')) {
            continue;
        }
        entries.set(path, { path, contents: unzipped[path] });
    }
    return { entries };
}
function findCdszEntryByBasename(extracted, basename) {
    const wanted = basename.toLowerCase();
    for (const entry of extracted.entries.values()) {
        const path = entry.path.toLowerCase();
        const slash = path.lastIndexOf('/');
        const entryBasename = slash >= 0 ? path.slice(slash + 1) : path;
        if (entryBasename === wanted) {
            return entry;
        }
    }
    return undefined;
}
function readCdszEntryAsText(entry) {
    return utf8Decoder.decode(entry.contents);
}
//# sourceMappingURL=cdszArchive.js.map